import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useRegister } from "./RegisterContext";
import { SESSION } from "@/config/session";

export const StickyBar = () => {
  const { openForm } = useRegister();
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 420);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100 }}
          animate={{ y: 0 }}
          exit={{ y: 100 }}
          transition={{ type: "spring", stiffness: 260, damping: 28 }}
          className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-md border-t border-zinc-200 px-4 py-2.5 flex items-center gap-3 shadow-[0_-10px_30px_-15px_rgba(0,0,0,0.25)]"
          data-testid="sticky-cta-bar"
        >
          <div className="leading-tight shrink-0">
            <p className="flex items-baseline gap-1.5"><span className="font-black text-green-600 text-lg">FREE</span><span className="line-through text-zinc-500 text-sm">₹999</span></p>
            <p className="text-[11.5px] text-ink font-semibold">{SESSION.shortLabel} • {SESSION.startTime}</p>
          </div>
          <button type="button" onClick={openForm} data-testid="sticky-cta-button" className="cta-btn cta-pulse flex-1 rounded-xl py-3 text-white font-extrabold text-[13px] tracking-wide">
            SECURE YOUR FREE SEAT
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export const TopStrip = () => (
  <div className="plum-band text-white text-center text-[11.5px] sm:text-[13px] font-semibold px-3 py-2" data-testid="top-strip">
    The Wealth Code Masterclass • {SESSION.shortLabel} • {SESSION.startTime} • Live On Zoom
  </div>
);
